import { getCanonicalSearchUrl } from '@eventbrite/redux-destination';
import { $FixMe } from '@eventbrite/ts-utils';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import React from 'react';
import {
    FOLLOWED_PROFILES,
    LIKED_EVENTS,
} from '../../../../constants/constants';
import {
    FOR_YOU,
    ONLINE_TAB,
    SEASONAL_TAB,
} from '../../../../constants/tabConfig';
import { BaseSeasonalContentShape, EventSearch } from '../../../../types/index';
import { SeeMore } from '../../components/SeeMore';

interface SeeMoreOfBucketProps {
    bucketKey?: string;
    seeMore?: { url?: string };
    onSeeMore: Function;
    searchCriteria?: EventSearch;
    shouldShowSeeMore?: boolean;
    locationSlug?: string;
    tabKey?: string;
    userId?: string;
    seasonalContent: BaseSeasonalContentShape[];
}

const SeeMoreOfBucket = (props: SeeMoreOfBucketProps) => {
    const {
        bucketKey,
        seeMore,
        onSeeMore,
        searchCriteria,
        shouldShowSeeMore,
        locationSlug,
        tabKey,
        userId,
        seasonalContent,
    } = props;

    let seeMoreUrl = seeMore;

    if (shouldShowSeeMore) {
        if (isEmpty(seeMore) && searchCriteria && !isEmpty(locationSlug)) {
            let q = '';

            if (tabKey === SEASONAL_TAB) {
                q = get(
                    seasonalContent,
                    'byDate.eventSearchQ',
                    get(seasonalContent, 'byDate.tabName', ''),
                );
                if (!isString(q)) {
                    q = (q as $FixMe).toString();
                }
            }

            const { price, tags, dates } = searchCriteria;

            seeMoreUrl = {
                url: getCanonicalSearchUrl({
                    slug: locationSlug,
                    price,
                    tags,
                    dates,
                    q,
                }),
            };
        }

        if (bucketKey === LIKED_EVENTS && tabKey === FOR_YOU) {
            seeMoreUrl = {
                url: `/u/${userId}/favorites/events`,
            };
        }

        if (bucketKey === FOLLOWED_PROFILES && tabKey === FOR_YOU) {
            seeMoreUrl = {
                url: `/u/${userId}/following`,
            };
        }

        if (tabKey === ONLINE_TAB) {
            seeMoreUrl = {
                url: '/d/online/all-events/',
            };
        }
    }

    return (
        <div data-testid="see-more-events">
            <SeeMore
                bucketKey={bucketKey}
                onClick={onSeeMore}
                seeMore={seeMoreUrl}
            />
        </div>
    );
};

export default SeeMoreOfBucket;
